GoldenSpins = {};

GoldenSpins.starterAnims = [];
GoldenSpins.goldSpinsReveals = [];
GoldenSpins.cloverBlankReveals = [];
GoldenSpins.goldSpinsReelSpins = [];
GoldenSpins.goldSpinsCompleted = [];
GoldenSpins.specialSymbols = [12, 14, 15, 16, 17, 18, 19];
GoldenSpins.respinData = undefined;
GoldenSpins.currentSpin = undefined;
GoldenSpins.currentCount = 1;
GoldenSpins.spinsUsed = 0;
GoldenSpins.isGoldenSpin = false;
GoldenSpins.isFirstSpin = true;
GoldenSpins.goldenSpinsCounter = undefined;
GoldenSpins.introTween = undefined;
GoldenSpins.animatingIntro = false;
GoldenSpins.spineContainer = null;
GoldenSpins.introSpineAnim = null;

GoldenSpins.create = function (json) {
  return new PIXI.Container();
};

GoldenSpins.onGameConfig = function () {};

GoldenSpins.getFilesRequired = function (json) {
  return [];
};

GoldenSpins.initialise = function () {
  GoldenSpins.goldenSpinsCounter = resourceManager.get("postReels:goldenSpinsCounter:value");

  GoldenSpins.burst = resourceManager.get("postReels:goldenSpinsCounter:backing");

  GoldenSpins.burst.visible = false;
  GoldenSpins.animatingIntro = false;

  GoldenSpins.counterEmitter = particleManager.createEmitter(
    "goldenSpinsSpark",
    "postReels:goldenSpinsCounter",
    0,
    -30,
    false
  );
  GoldenSpins.counterEmitter.particleEmitter.emit = false;
  GoldenSpins.counterEmitter.visible = true;

  GoldenSpins.spineContainer = resourceManager.get("postReels:spinsIntroContainer:spineContainer");
  GoldenSpins.introSpineAnim = resourceManager.createObject(
    "spine",
    "goldenSpinsIntroSpine",
    GoldenSpins.spineContainer,
    {
      name: "goldenSpinsIntro",
      defaultAnimation: "Golden_Spins",
    }
  );

  GoldenSpins.introSpineAnim.visible = false;

  // ANIM WAS GOING TOO SLOWLY
  GoldenSpins.introSpineAnim.spineObject.state.timeScale = 2;

  this.pulseTween = gsap.fromTo(
    GoldenSpins.burst.scale,
    {
      x: 0.6,
      y: 0.6,
    },
    {
      paused: true,
      delay: 0,
      duration: 0.5,
      x: 0.7,
      y: 0.7,
      yoyo: true,
      repeat: -1,
    }
  );
  this.pulseTween.time(0).restart(true);

  GoldenSpins.burst.rotation = 0;

  this.rotateTween = gsap.to(GoldenSpins.burst, {
    duration: 3,
    rotation: Math.PI * 2,
    repeat: -1,
    ease: "none",
  });
  this.rotateTween.time(0).restart(true);
};

GoldenSpins.start = async function () {
  GoldenSpins.scaleAndUpdateCounter(GoldenSpins.decreaseCounter.bind(this));
  GoldenSpins.spinsUsed++;
  GoldenSpins.currentSpin = GoldenSpins.goldenSpins.spins.shift();
  GoldenSpins.goldSpinsCompleted.push(GoldenSpins.currentSpin);
  GoldenSpins.isGoldenSpin = true;
  gameController.canSkipWin = false;
  gameController.coinsCurrentlySkippable = false;
  gameController.dimNoneWinningSymbolsBySymbolGroup(helper.getCollectSymbolsReelsInfo()); // << This dims every non coin type symbol.
  PrizePots.cleanUp(); // Destory all the pot prize tags because we know they're all going to respin.

  GoldenSpins.createGoldenSpinsAnims();
  await GoldenSpins.startGoldenSpins();
};

GoldenSpins.showIntro = function (cb) {
  return new Promise((res) => {
    PrizePots.cleanUp();
    gameController.dimAllSymbols(true);
    GoldenSpins.burst.visible = true;
    if (GoldenSpins.isFirstSpin) {
      GoldenSpins.animatingIntro = true;

      soundManager.play("goldenSpinsText");

      GoldenSpins.introSpineAnim.scale.set(1);
      GoldenSpins.introSpineAnim.visible = true;

      timerManager.delayAsync(700, () => {
        musicManager.playGoldenSpins();
      });

      GoldenSpins.introSpineAnim.play("Golden_Spins", false, 0, () => {
        gsap.to(GoldenSpins.introSpineAnim.scale, {
          duration: 0.35,
          ease: "linear",
          x: 0,
          y: 0,
          onComplete: () => {
            GoldenSpins.introSpineAnim.visible = true;
            GoldenSpins.animatingIntro = false;
            gameController.dimAllSymbols(false);
            res();
            if (cb) {
              cb();
            }
            GoldenSpins.isFirstSpin = false;
          },
        });
      });
    } else {
      res();
      if (cb) {
        cb();
      }
    }
  });
};

GoldenSpins.orientationChange = function () {
  if (GoldenSpins.introTween !== undefined) {
    if (GoldenSpins.introTween.progress() <= 0.9) {
      GoldenSpins.introTween.progress(0.2);
    }
  }
};

GoldenSpins.createGoldenSpinsAnims = function () {
  let symbols = GoldenSpins.getCoinSymbols();
  symbols.forEach(function (symbol) {
    GoldenSpins.createIndividualAnims(symbol.reel, symbol.row);
    GoldenSpins.hideSymbol(symbol);
  });
};

GoldenSpins.scaleAndUpdateCounter = function (cb) {
  let scale = GoldenSpins.goldenSpinsCounter.scale;
  gsap
    .timeline()
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.6,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      onComplete: () => {
        if (cb) {
          cb();
        }
      },
    })
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.4,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {},
    });
};

GoldenSpins.decreaseCounter = function () {
  let scale = GoldenSpins.goldenSpinsCounter.scale;
  gsap
    .timeline()
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.02,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      onComplete: () => {},
    })
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.02,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {
        GoldenSpins.currentCount--;
        GoldenSpins.goldenSpinsCounter.text = GoldenSpins.currentCount === -1 ? "1" : GoldenSpins.currentCount;
      },
    });
};

GoldenSpins.restoreCounter = function () {
  let scale = GoldenSpins.goldenSpinsCounter.scale;
  gsap
    .timeline()
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.2,
      ease: "linear",
      x: scale._x * 1.3,
      y: scale._y * 1.3,
      yoyo: true,
      repeat: 5,
      onComplete: () => {
        GoldenSpins.counterEmitter.particleEmitter.emit = true;
        GoldenSpins.counterEmitter.visible = true;
      },
    })
    .to(GoldenSpins.goldenSpinsCounter.scale, {
      duration: 0.4,
      ease: "linear",
      x: scale._x,
      y: scale._y,
      onComplete: () => {},
    });
  GoldenSpins.goldenSpinsCounter.text = gameController.goldenSpinsMeterAtEnd;
  GoldenSpins.currentCount = gameController.goldenSpinsMeterAtEnd;
  GoldenSpins.spinsUsed = 0;
  GoldenSpins.isFirstSpin = true;
};
GoldenSpins.resetCounter = function () {
  GoldenSpins.spinsUsed = 0;
  GoldenSpins.currentCount = 1;
  GoldenSpins.goldenSpinsCounter.text = GoldenSpins.currentCount;
};

GoldenSpins.getCoinSymbols = function () {
  //get all coin symbols
  let symbols = [];
  for (let i = 1; i < 4; ++i) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    for (let j = 0; j < reelVisual.appertureHeight; ++j) {
      if (GoldenSpins.coinOnSymbol(i, j)) {
        symbols.push({ reel: i, row: j });
      }
    }
  }
  return symbols;
};

GoldenSpins.createIndividualAnims = function (reel, row) {
  const height = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).height;
  const width = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).width;
  const spinScale = GoldenSpins.calculateSpinScale(reel);
  const reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const symbolSize = reelVisual.appertureHeight;

  const yOffset = symbolSize === 3 ? 10 : 5;

  const goldSpinsReelSpin = resourceManager.createObject(
    "movie",
    `goldSpinsReelSpin:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: "goldSpinsReelSpin",
      x: -15,
      y: row * height - yOffset,
      scaleY: spinScale,
      loop: true,
    }
  );

  goldSpinsReelSpin.gotoAndStop(0);
  goldSpinsReelSpin.play();

  const revealDefinition = symbolSize < 5 ? "cloverRevealLong" : "cloverReveal";

  const revealPositioning = GoldenSpins.calculateRevealPositioning(reel);
  const yPos = row * height + height / 2;
  const goldSpinsReveal = resourceManager.createObject(
    "movie",
    `goldSpinsReveal:reel${reel}:symbol${row}`,
    `slotContainer:reelContainer:reel${reel}`,
    {
      definition: revealDefinition,
      x: width / 2,
      y: yPos - revealPositioning.yOffset,
      scaleY: revealPositioning.scale,
      anchor: 0.5,
      loop: false,
    }
  );
  goldSpinsReveal.visible = false;
  goldSpinsReveal.onComplete = function () {
    goldSpinsReveal.visible = false;
  };

  GoldenSpins.goldSpinsReelSpins.push(goldSpinsReelSpin);
  GoldenSpins.goldSpinsReveals.push(goldSpinsReveal);
};

GoldenSpins.hideSymbol = function (symbol) {
  gameData.reels[symbol.reel].showSymbol(symbol.row, false);
};

GoldenSpins.startGoldenSpins = async function () {
  resourceManager.get("buttonContainer:buttonBar:slamStopButton:button:buttonSprite").visible = false;

  CoinsView.canSkipCoins = false;
  if (gameController.lockedCoins.length === 0) {
    gameController.lockCoins();
  }
  const data = gameController.goldenSpins;
  let newCoins = [...GoldenSpins.currentSpin.newCashCoins];
  let totalReveals = newCoins.length;

  GoldenSpins.burst.visible = true;
  this.pulseTween.time(0).restart(true);
  this.rotateTween.time(0).restart(true);

  await GoldenSpins.revealResults(newCoins, totalReveals);

  GoldenSpins.removeAllAnims();
  gameController.dimNoneWinningSymbolsBySymbolGroup(helper.getCollectSymbolsReelsInfo()); //Dim every none coin symbol
  gameController.arrCount = 0;
  PrizePots.onCompleteCallback = GoldenSpins.onComplete.bind(this);
  PrizePots.awardPrizePot();
};

GoldenSpins.onComplete = async function () {
  gameController.arrCount = 0;
  gameController.canSkipWin = true;
  gameController.coinsCurrentlySkippable = true;
  CoinCollectionController.doCollection();
  //CoinsView.animateCashCoins();

  resourceManager.get("buttonContainer:buttonBar:slamStopButton:button:buttonSprite").visible = true;

  GoldenSpins.burst.visible = false;
  this.pulseTween.time(0).restart(false);
  this.rotateTween.time(0).restart(false);
};

GoldenSpins.removeAllAnims = function () {
  GoldenSpins.starterAnims.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (GoldenSpins.starterAnims.length) {
    GoldenSpins.starterAnims.shift();
  }
  GoldenSpins.goldSpinsReveals.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (GoldenSpins.goldSpinsReveals.length) {
    GoldenSpins.goldSpinsReveals.shift();
  }

  GoldenSpins.goldSpinsReelSpins.forEach((anim) => {
    resourceManager.destroyObject(anim.name);
  });
  while (GoldenSpins.goldSpinsReelSpins.length) {
    GoldenSpins.goldSpinsReelSpins.shift();
  }
};

GoldenSpins.lockCoin = function (coin) {
  const scale = gameController.calculateCoinLockScale(coin.coord.reel);

  const coinLock = resourceManager.createObject(
    "movie",
    `lockedCoins:reel${coin.coord.reel}:symbol${coin.coord.row}`,
    `slotContainer:reelContainer:reel${coin.coord.reel}`,
    {
      definition: "coinLock",
      x: 0,
      y: 0,
      loop: true,
      anchor: 0.5,
      scaleY: scale,
    }
  );

  const symbol = resourceManager.get(`slotContainer:reelContainer:reel${coin.coord.reel}:symbol${coin.coord.row}`);
  const symbolPos = helper.getLocalFromGlobalPosition(symbol, coinLock);

  coinLock.x = symbolPos.x;
  coinLock.y = symbolPos.y;

  const pulseTween = gsap.fromTo(
    coinLock.scale,
    {
      x: 1,
      y: scale,
    },
    {
      paused: true,
      delay: 0,
      duration: 0.5,
      x: 1.1,
      y: scale * 1.1,
      yoyo: true,
      repeat: 1,
    }
  );
  pulseTween.time(0).restart(true);
  coinLock.gotoAndStop(0);
  coinLock.play();
  gameController.lockedCoins.push(coinLock);
};

GoldenSpins.resumeSpins = function (blanks) {
  blanks.forEach((blank) => {
    gameData.reels[blank.coord.reel].showSymbol(blank.coord.row, false);

    let cloverReelSpin = resourceManager.get(
      `slotContainer:reelContainer:reel${blank.coord.reel}:cloverReelSpin:reel${blank.coord.reel}:symbol${blank.coord.row}`
    );
    cloverReelSpin.visible = true;
    cloverReelSpin.gotoAndStop(0);
    cloverReelSpin.play();

    let reelSpinBackingAnim = resourceManager.get(
      `slotContainer:reelContainer:reel${blank.coord.reel}:cloverBackingSpin:reel${blank.coord.reel}:symbol${blank.coord.row}`
    );
    reelSpinBackingAnim.visible = true;
    reelSpinBackingAnim.gotoAndStop(0);
    reelSpinBackingAnim.play();
  });
};

GoldenSpins.revealResults = async function (newCoins, totalReveals) {
  GoldenSpins.emptyGoldCoins();
  const revealResultPromises = [];
  const spinStagger = 300;
  for (let j = 0; j < totalReveals; j++) {
    await timerManager.delayAsync(spinStagger);
    let nextReveal = newCoins.shift();
    revealResultPromises.push(GoldenSpins.revealResult(nextReveal));
  }
  await Promise.all(revealResultPromises);
};

GoldenSpins.emptyGoldCoins = function () {
  for (let index = 0; index < gameController.coins.length; index++) {
    const coin = gameController.coins[index];
    if (coin.type === "Pot") {
      CoinsView.PotsSavedForSkippFunction.push(coin);
    }
  }
  while (gameController.coins.length > 0) {
    gameController.coins.shift();
  }
};

GoldenSpins.getNewCoinID = (amount, symbolSize) => {
  const fishSymbolThresholds = [
    { min: 0, max: 3, id: 0 },
    { min: 3, max: 4, id: 1 },
    { min: 5, max: 6, id: 2 },
    { min: 8, max: 10, id: 3 },
    { min: 15, max: 20, id: 4 },
    { min: 25, max: Infinity, id: 5 },
  ];

  const fishSymbolMapOffsetToID = {
    0: 100,
    1: 106,
    2: 112,
    3: 118,
    4: 124,
  };

  const amountAsMulti = amount / gameController.globalHelperGetCurrentModeStake(true);

  const cashID = fishSymbolThresholds.find(
    (threshold) => amountAsMulti >= threshold.min && amountAsMulti <= threshold.max
  ).id;

  const newSymbolID = fishSymbolMapOffsetToID[symbolSize] + cashID;

  return newSymbolID;
};

GoldenSpins.revealResult = async function (nextReveal) {
  let reel = nextReveal.coord.reel;
  let row = nextReveal.coord.row;
  let goldSpinsReelSpin = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:goldSpinsReelSpin:reel${reel}:symbol${row}`
  );
  // let goldSpinsBacking = resourceManager.get(
  //   `slotContainer:reelContainer:reel${reel}:goldSpinsBacking:reel${reel}:symbol${row}`
  // );
  let goldSpinsReveal = resourceManager.get(
    `slotContainer:reelContainer:reel${reel}:goldSpinsReveal:reel${reel}:symbol${row}`
  );
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let symbolSize = reelVisual.appertureHeight - 3;

  GoldenSpins.fadeOutAnim(goldSpinsReelSpin);
  //GoldenSpins.fadeOutBacking(goldSpinsBacking);
  return new Promise((res) => {
    if (nextReveal.type === "Cash") {
      goldSpinsReveal.visible = true;
      goldSpinsReveal.onComplete = () => {
        goldSpinsReveal.visible = false;
        gameController.slotMachine.dimSymbol(reel, row, false, 0.1);
        res();
      };
      goldSpinsReveal.gotoAndStop(0);
      goldSpinsReveal.play();

      timerManager.delayAsync(500, null, () => {
        const coinIndex = GoldenSpins.getNewCoinID(nextReveal.amount, symbolSize);
        gameController.coins.push(nextReveal);
        GoldenSpins.updateSymbolOnReel(reel, row, coinIndex);
        gameData.reels[reel].setReelSymbol(row, coinIndex);
        gameData.reels[reel].showSymbol(row, true);
        soundManager.play("coinLand");
      });
    } else if (nextReveal.type === "Pot") {
      timerManager.delayAsync(500, null, () => {
        const potIndex = 19 + 20 * symbolSize;
        gameController.coins.push(nextReveal);
        GoldenSpins.updateSymbolOnReel(reel, row, potIndex);
        gameData.reels[reel].setReelSymbol(row, potIndex);
        gameData.reels[reel].showSymbol(row, true);
        soundManager.play("horseshoeLand");
      });

      cloverReveal.visible = true;
      cloverReveal.onComplete = () => {
        cloverReveal.visible = false;
        gameController.slotMachine.dimSymbol(reel, row, false, 0.1);
        GoldenSpins.lockCoin(nextReveal);
        res();
      };
      cloverReveal.gotoAndStop(0);
      cloverReveal.play();
    }
  });
};

GoldenSpins.updateSymbolOnReel = function (reel, row, newID) {
  for (let i = 0; i < gameController.symbolMap.length; i++) {
    const symbol = gameController.symbolMap[i];
    if (symbol.cell.reel === reel && symbol.cell.row === row) {
      symbol.symbolId = newID;
    }
  }
};

GoldenSpins.fadeOutAnim = function (anim) {
  let fadeTween = gsap.fromTo(
    anim,
    {
      visible: true,
      alpha: 1,
    },
    {
      duration: 0.5,
      alpha: 0,
      onComplete: () => {
        anim.stop();
        anim.visible = false;
        anim.alpha = 1;
      },
    }
  );
  fadeTween.time(0).restart(true);
};
// GoldenSpins.fadeOutBacking = function (backing) {
//   let fadeTween = gsap.fromTo(
//     backing,
//     {
//       visible: true,
//       alpha: 1,
//     },
//     {
//       duration: 0.5,
//       alpha: 0,
//     }
//   );
//   fadeTween.time(0).restart(true);
// };

GoldenSpins.dimAllSymbols = function (dim) {
  for (let reel = 0; reel < gameData.reels.length; reel++) {
    for (let row = 0; row < gameData.reels[reel].appertureHeight + 1; row++) {
      let symID = gameController.slotMachine.getSymbolId(reel, row);
      gameController.slotMachine.dimSymbol(reel, row, dim, 0.1);
    }
  }
};

GoldenSpins.getNextReveal = function (newCoins) {
  if (newCoins.length === 0) {
    return blanks.shift();
  }
  if (blanks.length === 0) {
    return newCoins.shift();
  }
  if (newCoins[0].coord.reel < blanks[0].coord.reel) {
    return newCoins.shift();
  } else if (newCoins[0].coord.reel > blanks[0].coord.reel) {
    return blanks.shift();
  } else {
    if (newCoins[0].coord.row < blanks[0].coord.row) {
      return newCoins.shift();
    } else if (newCoins[0].coord.row > blanks[0].coord.row) {
      return blanks.shift();
    }
  }
};

GoldenSpins.calculateScale = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return 1.65;
    case 4:
      return 1;
    case 5:
      return 1;
    case 6:
      return 0.75;
    case 7:
      return 0.65;
  }
};
GoldenSpins.calculateSpinScale = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return 1.6;
    case 4:
      return 1.2;
    case 5:
      return 1;
    case 6:
      return 0.8;
    case 7:
      return 0.7;
  }
};

GoldenSpins.calculateRevealPositioning = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return { scale: 1, yOffset: 30 };
    case 4:
      return { scale: 0.75, yOffset: 30 };
    case 5:
      return { scale: 0.9, yOffset: 25 };
    case 6:
      return { scale: 0.8, yOffset: 20 };
    case 7:
      return { scale: 0.7, yOffset: 15 };
  }
};

GoldenSpins.coinOnSymbol = function (reel, row) {
  return gameController.coinAwardsBeforeGoldenSpins.coins.some(
    (coin) => coin.coin.coord.reel === reel && coin.coin.coord.row === row
  );
};

resourceManager.registerObjectType(
  "GoldenSpins",
  GoldenSpins.create,
  GoldenSpins.initialise,
  GoldenSpins.getFilesRequired
);
